module.exports = __webpack_public_path__ + "img/hj001.009d0187.jpg";